/* Custom pedals in the cart drawer and on the cart page: each line shows the pedal as the customer built it.
   The Pedal Customizer saves a picture of every build it adds (localStorage "dsa-renders", keyed by the line's
   "_Build" property). A line whose picture isn't in this browser keeps its variant image. Loaded on every page
   by sections/dsa-cart-images.liquid. */
(() => {
  if (window.DSACart) return;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const ROWS = "[id^='CartDrawer-Item-'], [id^='CartItem-']";
  let busy = false, again = false, queued = false;

  const renders = () => { try { return JSON.parse(localStorage.getItem("dsa-renders")) || []; } catch (e) { return []; } };

  async function swap() {
    if (busy) { again = true; return; }
    // rows Dawn has (re)drawn since the last look
    const rows = [...document.querySelectorAll(ROWS)].filter(r => { const i = r.querySelector("img.cart-item__image"); return i && !i.hasAttribute("data-dsa-checked"); });
    if (!rows.length) return;
    const saved = renders();
    rows.forEach(r => r.querySelector("img.cart-item__image").setAttribute("data-dsa-checked", ""));
    if (!saved.length) return;
    busy = true;
    try {
      const r = await fetch(root + "cart.js", { headers: { Accept: "application/json" } });
      const cart = r.ok ? await r.json() : null;
      if (!cart) return;
      rows.forEach(row => {
        const item = cart.items[Number(row.id.replace(/\D+/g, "")) - 1];
        const build = item && item.properties && item.properties._Build;
        // only when the row really is this line: its link names the same variant
        if (!build || !row.querySelector(`a[href*="variant=${item.variant_id}"]`)) return;
        const hit = saved.find(e => e && e.k === build); if (!hit) return;
        const img = row.querySelector("img.cart-item__image");
        img.removeAttribute("srcset"); img.removeAttribute("sizes");
        img.src = hit.u; img.alt = `Your custom ${item.variant_title || item.product_title}, as you built it`;
        img.setAttribute("data-dsa-build", "");
      });
    } catch (e) {
    } finally {
      busy = false;
      if (again) { again = false; swap(); }
    }
  }

  const later = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; swap(); }); };
  new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", later); else later();
  window.DSACart = { refresh: later };
})();
